/**
 * Alpine.js component for forms that forces unchecked checkboxes to submit as "false"
 *
 * Usage:
 * <form x-data="forceCheckboxFalse">
 *   <input type="checkbox" name="myCheckbox" />
 * </form>
 */
export function forceCheckboxFalse() {
    return {
        init() {
            // Handle HTMX requests
            this.$el.addEventListener('htmx:configRequest', (event) => {
                this.$el.querySelectorAll('input[type="checkbox"]').forEach(cb => {
                    if (!cb.name || cb.hasAttribute('data-allow-empty')) return;

                    if (!cb.checked) {
                        event.detail.parameters[cb.name] = "false";
                    }
                });
            });

            // Handle standard form submissions
            this.$el.addEventListener('submit', (event) => {
                const data = new FormData(this.$el);

                this.$el.querySelectorAll('input[type="checkbox"]').forEach(cb => {
                    if (!cb.name || cb.hasAttribute('data-allow-empty')) return;

                    if (!cb.checked && !data.has(cb.name)) {
                        const hidden = document.createElement('input');
                        hidden.type = 'hidden';
                        hidden.name = cb.name;
                        hidden.value = 'false';
                        this.$el.appendChild(hidden);
                    }
                });
            }, true);
        }
    };
}



